<app-header (childEvent)="toggleSidebar()"></app-header>
<div class="content-wrapper">
  <router-outlet></router-outlet>
</div>
<div *ngIf="isLoggedIn" class="sidebar-wrapper" [@slideInOut]="menuState">
  <app-sidebar (childEvent)="toggleSidebar()"></app-sidebar>
</div>
<app-footer id="footer"></app-footer>
